/**
 * @generated SignedSource<<ea4ec194b7b6fbe8e1d1b93c8a7d3417>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DuplicateModelResultStatus = "ERROR" | "SUCCESS" | "WARNING";
export type ModelDuplicateTargetInput = {
  imageUrl?: string | null;
  name: string;
  salesChannelId: string;
  sku: string;
};
export type customizerTestDuplicateMutation$variables = {
  id: string;
  targets: ReadonlyArray<ModelDuplicateTargetInput>;
};
export type customizerTestDuplicateMutation$data = {
  readonly duplicateModel: {
    readonly productIDs: ReadonlyArray<number> | null;
    readonly resultMessage: string | null;
    readonly status: DuplicateModelResultStatus;
  };
};
export type customizerTestDuplicateMutation = {
  response: customizerTestDuplicateMutation$data;
  variables: customizerTestDuplicateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "targets"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "targets",
        "variableName": "targets"
      }
    ],
    "concreteType": "DuplicateModelResult",
    "kind": "LinkedField",
    "name": "duplicateModel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "productIDs",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "resultMessage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "customizerTestDuplicateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "customizerTestDuplicateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e602608650029fe329d63af90d363a28",
    "id": null,
    "metadata": {},
    "name": "customizerTestDuplicateMutation",
    "operationKind": "mutation",
    "text": "mutation customizerTestDuplicateMutation(\n  $id: ID!\n  $targets: [ModelDuplicateTargetInput!]!\n) {\n  duplicateModel(id: $id, targets: $targets) {\n    productIDs\n    resultMessage\n    status\n  }\n}\n"
  }
};
})();

(node as any).hash = "6ceaebeb2ed51ba71063b03d3085ce45";

export default node;
